import { render } from "./header.vue?vue&type=template&id=656a7cf3&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=656a7cf3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-656a7cf3"]])

export default __exports__